import {DateTime} from 'luxon';
import React, {useState} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {PurchaseButton} from '../../../../../libs/shared/ui/src/components/buttons/purchaseButton';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {LightUserThemeProvider} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {createSelector} from '../../../../../srcCommon/helpers/reselectHelpers';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {ConnectedWithRepBanner} from '../../../../settings/billing/common/banners/connectedWithRepBanner';
import {InAppChoosePlansModal} from '../../../../settings/billing/common/modals/inAppChoosePlansModal';
import {getCompanyCreatedAt, getDaysLeftInTrial} from '../../../../store/data/company/companySelectors';

/*
 * Selectors.
 */

const getDaysSinceCreation = createSelector([getCompanyCreatedAt], (createdAt) => {
  const now = DateTime.now();
  const creationDate = DateTime.fromMillis(createdAt);
  return now.diff(creationDate, 'days').days;
});

/*
 * Component.
 */

export const BottomBarPurchaseButton = () => {
  const daysSinceCreation = useAppSelector(getDaysSinceCreation);
  const daysLeftInTrial = useAppSelector(getDaysLeftInTrial);

  const [showPlanModal, setShowPlanModal] = useState(false);
  const [hasConnectedWithRep, setHasConnectedWithRep] = useState(false);

  return (
    <>
      <LightUserThemeProvider>
        <PurchaseButton size={VisualSizesEnum.SMALL} onClick={() => setShowPlanModal(true)}>
          {daysSinceCreation <= 3 && daysLeftInTrial > 3 ? (
            <Trans id="bottom-bar-purchase-button-early">Compare plans</Trans>
          ) : (
            <Trans id="bottom-bar-purchase-button-late">Buy now</Trans>
          )}
        </PurchaseButton>
      </LightUserThemeProvider>
      {showPlanModal && (
        <InAppChoosePlansModal
          onRequestClose={() => setShowPlanModal(false)}
          showConnectWithRepBanner={() => setHasConnectedWithRep(true)}
        />
      )}
      {hasConnectedWithRep && <ConnectedWithRepBanner onDismissClick={() => setHasConnectedWithRep(false)} />}
    </>
  );
};
